import React from 'react';
import './About.css';
import { useLanguage } from '../LanguageContext';

const About = () => {
	const { t } = useLanguage();

	return (
		<section id="about" className="about-section">
			<div className="about-container">
				<div className="about-left">
					<div className="about-label">{t('whoWeAre')}</div>
					<h2 className="about-heading">{t('buildingTomorrow')} <span className="highlight">{t('tomorrows')}</span><br />{t('technologyToday')}</h2>
					<p className="about-text">{t('aboutText1')}</p>
					<p className="about-text">{t('aboutText2')}</p>
					<button className="learn-more-btn">{t('learnOurStory')}</button>
				</div>
				<div className="about-right">
					<div className="info-card card-large">
						<div className="card-letter">H</div>
					</div>
					<div className="info-card card-small">
						<div className="card-year">{t('foundedWithVision')}</div>
					</div>
          		<div className="info-card card-medium">
						<div className="card-text">{t('youngAndGrowing')}</div>
					</div>
          	<div className="info-card">
						<div className="card-description">Tech</div>
					</div>
			
				
				</div>
			</div>
		</section>
	);
};

export default About;
